import styled from "styled-components";

export const LauncherButton = styled.button`
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 10000;
  padding: 0;
  border: none;
  margin: 0;
  background: transparent;
  cursor: pointer;
  line-height: 0;

  @media (max-width: 767px) {
    right: 16px;
  }
`;

export const LauncherImage = styled.img`
  display: block;
  width: 80px;
  height: 80px;
`;
